import React, { Component, ComponentType } from 'react'
import { connect } from 'react-redux'
import {
  Route,
  Redirect,
  RouteProps,
  RouteComponentProps,
} from 'react-router-dom'
import queryString from 'query-string'

import { createSession } from '../actions/sessionActions'
import { BadgeGate } from '../features/common/permissions/badgeGate'
import { CalltoolsAgentCheck } from '../features/calltools/calltoolsAgentCheck'

export interface Props extends RouteProps {
  component: ComponentType<RouteComponentProps<any>>
  isAuth: boolean
  requiredBadges?: string[]
  anyBadges?: string[]
  path?: any
  exact?: boolean
  disableUI?: boolean
  location?: Location
}

export class AuthRoute extends Component<Props> {
  render() {
    const {
      component: Component,
      isAuth,
      requiredBadges = [],
      anyBadges,
      location,
      ...rest
    } = this.props

    const redirectQueryString = queryString.stringify({
      return_to: `${location?.pathname}${location?.search ?? ''}`,
    })

    return (
      <Route
        {...rest}
        render={(props) => {
          switch (true) {
            case !isAuth:
              return (
                <Redirect
                  to={{
                    pathname: '/login',
                    search: redirectQueryString,
                    state: { from: props.location },
                  }}
                />
              )
            case Boolean(requiredBadges) || Boolean(anyBadges):
              return (
                <BadgeGate requiredBadges={requiredBadges} anyBadges={anyBadges}>
                  <CalltoolsAgentCheck>
                    <Component {...props} />
                  </CalltoolsAgentCheck>
                </BadgeGate>
              )
            default:
              return (
                <CalltoolsAgentCheck>
                  <Component {...props} />
                </CalltoolsAgentCheck>
              )
          }
        }}
      />
    )
  }
}

const mapStateToProps = (state) => ({
  isAuth: state.session.isAuth,
})

export default connect(mapStateToProps, {
  createSession,
})(AuthRoute)
